import {useReportingResource} from '@/hooks/useReportingResource';
import {downloadFile} from '@/lib/api';
import NativeWordHistory from './NativeWordHistory';
import CompletionAssessmentForm from './CompletionAssessmentForm';
export const ASSESSMENT_FIELDS=[
 ['required_representations','Representasi yang diperlukan'],
 ['management_request','Naskah permintaan kepada manajemen'],
 ['letter_date','Tanggal surat aktual (YYYY-MM-DD; kosong bila belum diperoleh)'],
 ['date_signatory_verification','Verifikasi tanggal, identitas dan kewenangan penandatangan'],
 ['refusal_modification','Evaluasi penolakan atau modifikasi'],
 ['reporting_consequences','Konsekuensi terhadap pelaporan auditor'],
 ['conclusion','Kesimpulan auditor atas pekerjaan aktual'],
];
export default function WrittenRepresentations({id}){
 const resource=useReportingResource(id,'written-representations');
 const evidence=useReportingResource(id,'evidence');
 const areas=useReportingResource(id,'audit-areas');
 if(resource.error)return <p role="alert">{resource.error}</p>;
 if(!resource.data)return <p>Memuat representasi tertulis…</p>;
 const data=resource.data;
 return <section><p className="text-xs mb-3">Catat permintaan dan hasil aktual. Status respons tidak menggantikan bukti atau verifikasi tanda tangan. Penolakan atau modifikasi memerlukan evaluasi dan konsekuensi pelaporan yang didokumentasikan.</p>
 {(evidence.error||areas.error)&&<p role="alert">{evidence.error||areas.error}</p>}
 <CompletionAssessmentForm key={`${id}:${data.mutation_version||0}`} id={id} data={data} fields={ASSESSMENT_FIELDS}
 title="C150 — Representasi Tertulis" endpoint={`/engagements/${id}/written-representations`} prefix="representation" testId="written-representation-assessment"
 evidence={evidence.data||[]} reloadEvidence={evidence.reload} reloadAssessment={resource.reload} mutate={resource.mutate} busy={resource.busy}
 classifications={['Pending','Received','Modified','Refused']} choiceField="response_status" choiceLabel="Status respons aktual"
 extraWork={{response_status:data.response_status||'Pending',audit_area_keys:data.audit_area_keys||[]}}
 referenceGroups={[{key:'audit_area_keys',label:'Area audit terkait',options:(Array.isArray(areas.data)?areas.data:[]).map(a=>({value:a.area_key,label:a.area_key}))}]}/>
 <button type="button" className="border rounded p-2 text-xs" disabled={!data.id} onClick={()=>downloadFile(`/engagements/${id}/written-representations/export/docx`,'C150-working-copy.docx')}>Ekspor Word C150</button>
 <NativeWordHistory id={id} exportType="C150" recordId={data.id}/>
 </section>;
}
